<template>
    <div class="section-coupon6">
        <div class="text-descrition">{{title}}</div>
        <div class="text-campaign">{{description}}</div>
        <div class="box-icon-star">
            <div class="icon-star" v-for="(v,k) in allItem" :key="k">
                <img class="img-fluid" src="@/assets/icon/mission_icon_inactive.svg"
                    v-if="(k+1) > productCollect"/>
                <img class="img-fluid" src="@/assets/icon/mission_icon_active.svg" 
                    v-if="(k+1) <= productCollect"/>
            </div>
        </div>
        <div class="text-collect">{{textCollect}}</div>
        
        <div class="btn-more-collect disable_checkin" v-if="isAlreadyCheckedIn()">
            <div class="btn-txt">
                {{lbl.btn_next_day}}
            </div>
        </div>
        <div class="btn-more-collect" @click="clickToCheckin()" v-if="!isAlreadyCheckedIn() && productCollect < allItem">
            <div class="btn-txt">
                {{lbl.btn}}
            </div>
        </div>
    </div>
</template>
<script>
//import CacheHelper from "@/helper/CacheHelper.js";
//core
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";

//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js"; 

export default {
    name: 'CheckIn',
    mixins: [AccountMixin, ErrorApiMixin],
    props:{
        lbl: Object,
        modalController: Object,
        isLoading: Boolean,
        badgeDetailObj: Object,
        badgeDayDetailObj: Object,
    },
    data: function () {
        return {
            title: '',
            description: '',
            textCollect: '',
            badgeDetail: null,
            badgeDayDetail: null,
            allItem: 0,
            productCollect: null,
            itemPerRound: 7,
        };
    },
    created: function(){
        this.initialMission(this.badgeDetailObj, this.badgeDayDetailObj);
    },
    methods:{
        initialMission: function(badgeDetail, badgeDayDetail) {   
            if (badgeDetail) {
                this.badgeDetail = badgeDetail;
            }
            if (badgeDayDetail) {
                this.badgeDayDetail = badgeDayDetail;
            }
            if(!this.badgeDetail) return;
            if(!this.badgeDayDetail) return;  

            var mission = this.badgeDetail; 

            var info = null;
            if(mission.CustomInfo){
                info = JSON.parse(mission.CustomInfo);
                this.title = info.l_title; 
                this.title = info.d_information || "d_information";
                this.description = info.d_description;
            }

            this.allItem = (mission.Missions[0].Value % this.itemPerRound) + this.itemPerRound;
            this.productCollect = mission.Missions[0].Current % this.itemPerRound;

            this.textCollect = `${this.lbl.desc} ${this.productCollect}/${this.allItem}`; 
            //console.log("textCollect", this.textCollect, badgeDetail, badgeDayDetail);
            //this.testCheckin();
        },
        isAlreadyCheckedIn: function() { 
            //return false;
            return this.badgeDayDetail.IsObtain; 
        },
        clickToCheckin: function() {  
            this.toggleLoading(true); 
            var token = this.getToken();
            BzbsProfile.apiPostCheckIn(token).subscribe((res) => {
                this.toggleLoading(false);
                this.handleResponseCheckin(res);
 
            }, (err) => {
                this.toggleLoading(false);
                this.errorApi(err);
            });
        }, 
        handleResponseCheckin: function (res) { 
            if (res.buzzebees && res.buzzebees.badges && res.buzzebees.badges.length > 0) { 
                let badg7Day = res.buzzebees.badges.find(b => b.id && b.id.toLowerCase() == "bioderma_checkin7day");
                if (badg7Day) { 
                    this.$emit('showSuccessCheckin7day', badg7Day.points);
                }
                else {
                    let badg1Day = res.buzzebees.badges.find(b => b.id && b.id.toLowerCase() == "bioderma_checkin1day");
                    if (badg1Day) { 
                        this.$emit('showSuccessCheckin1Day'); 
                    }
                }
            }  
            //sthis.$emit('showSuccessCheckin1Day'); 
        },
        //utilities
        showLoading: function () {
            if (this.isLoading) return true;
            this.toggleLoading(true);

            return false;
        },
        hideLoading: function () {
            this.toggleLoading(false);
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        },
        testCheckin: function () {
            let res = {
                "buzzebees": {
                    "points": 30,
                    "updated_points": {
                        "points": 122,
                        "time": 1700551808
                    }, 
                    "badges": [
                        {
                            "id": "bioderma_checkin1day",
                            "name": "bioderman checkin 1 day",
                            "level": 2,
                            "points": 0,
                            "unlocked_by_others": false,
                            "auto_redeem": null,
                            "description": null,
                            "fb_description": null,
                            "IsSkipNoti": false,
                            "CustomInfo": null,
                            "UserLevel": 0,
                            "IsSkipNextNoti": false,
                            "error": null,
                            "LineMessageSetting": null
                        },
                        {
                            "id": "bioderma_checkin7day",
                            "name": "bioderma checking 7 day",
                            "level": 1,
                            "points": 30,
                            "unlocked_by_others": false,
                            "auto_redeem": null,
                            "description": null,
                            "fb_description": null,
                            "IsSkipNoti": false,
                            "CustomInfo": null,
                            "UserLevel": 0,
                            "IsSkipNextNoti": false,
                            "error": null,
                            "LineMessageSetting": null
                        }
                    ]
                }
            }
            this.handleResponseCheckin(res);
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay.scss';
@import '@/style/input/BaseButton.scss';

.section-coupon6{
    text-align: center;

    .text-descrition{
        color: $bright-gray;
        padding: 40px 0 20px;
    }

    .text-campaign{
        color: $dark-blue;
        font-family: $medium;
        font-size: 1.18rem;
    }

    .box-icon-star{
        @extend %display-flex;
        width: 85%;
        margin: auto;
        padding: 100px 0 80px;
        justify-content: center;

        .icon-star{
            flex: 0 0 calc(100% / 4);
            width: calc(100% / 4);
        }
    }

    .text-collect{
        color: $pink;
        font-family: $medium;
        font-size: 1.375rem;
    }

    .btn-more-collect{
        @include btn-wrapper();
        width: 90%;
        margin: 60px auto 40px;

        &.disabled{
            opacity: 1;
            background-color: rgba($border-gray, 0.17);
            box-shadow: $box-shadow;

            .btn-txt{
                color: $label-gray;
            }
        }
        &.disable_checkin {
            opacity: 1;
            background-color: #cbcbcb;
            box-shadow: $box-shadow;

            .btn-txt{
                color: $label-gray;
            }
        }
    }
}
</style>